var map = {
	"./icon-arrow-down.svg": 228,
	"./icon-award.svg": 347,
	"./icon-card.svg": 1283,
	"./icon-currency.svg": 618,
	"./icon-discuss.svg": 619,
	"./icon-dynamic-detail.svg": 620,
	"./icon-dynamic.svg": 1284,
	"./icon-ebook.svg": 621,
	"./icon-filter.svg": 1285,
	"./icon-host.svg": 622,
	"./icon-hot.svg": 1286,
	"./icon-identification.svg": 623,
	"./icon-introduce.svg": 624,
	"./icon-invite.svg": 625,
	"./icon-live.svg": 626,
	"./icon-plus.svg": 348,
	"./icon-reward.svg": 627,
	"./icon-shopping-cart.svg": 628,
	"./icon-suggest.svg": 349,
	"./icon-talk.svg": 1287,
	"./icon-write.svg": 629
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1282;


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/icon\-.*\.svg$
// module id = 1282
// module chunks = 0